// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationSharedStateModels {
    static getAttributeTypeMap() {
        return LocationSharedStateModels.attributeTypeMap;
    }
}
LocationSharedStateModels.discriminator = undefined;
LocationSharedStateModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<LocationSharedStateModel>"
    }
];
//# sourceMappingURL=locationSharedStateModels.js.map